import {
  Button,
  Form,
  Space,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Table,
  TreeSelect,
  Modal,
  Popconfirm,
} from "../../component/antdImports";
import "./style.css";
import Cookies from "universal-cookie";
import { useState, useEffect, useRef } from "react";
import {
  url_get_detail_cv,
  url_get_list_cv,
  // url_get_list_status_cv,
  url_change_status_cv,
  // url_get_list_district,
  url_get_meeting_room,
  // url_get_regis_meeting,
  // url_regis_meeting,
  url_get_check_cv,
  // url_regis_interview,
  url_get_list_interview,
  url_add_cv_interview,
  url_delete_file_cv,
  url_delete_data_cv,
  url_export_cv,
} from "../../../constants";
import { authAxios } from "../../../utils";
import moment from "moment";
import {
  EditOutlined,
  SearchOutlined,
  FileSyncOutlined,
  // ScheduleOutlined,
  FileSearchOutlined,
  // FileAddOutlined,
  DeleteOutlined,
  ScheduleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import ModalEditCandidate from "./editCandidate/index";
// import ModalViewMeeting from "./viewMeeting/index";
import ModalCheckCV from "./CheckCV/index";
import ModalAddCVInterview from "./addCVInterview/index";
import fnFileDownload from "js-file-download";

import { useSelector } from "react-redux";
import {
  openNotificationWithIcon,
  useScreenSize,
  validateMessages,
} from "../../Function";
import { AutoComplete } from "antd";

const { Option } = Select;
const { RangePicker } = DatePicker;
const cookies = new Cookies();
// const dateFormat = "DD/MM/YYYY";
const rangeConfig = {
  rules: [
    {
      type: "array",
      required: true,
      message: "Vui lòng chọn thời gian!",
    },
  ],
};
const ModalChangeStatus = ({
  isModalChangeStatus,
  setIsModalChangeStatus,
  dataDetailCandidate,
  listStatusCV,
  onFinishChangeStatus,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    if (isModalChangeStatus) {
      form.setFieldsValue({
        code_cv: dataDetailCandidate.code_cv,
        birthday:
          dataDetailCandidate.birthday != null
            ? moment(dataDetailCandidate.birthday, "YYYY-MM-DD")
            : undefined,
      });
    }
  }, [form, isModalChangeStatus, dataDetailCandidate]);

  return (
    <Modal
      title={`Chuyển trạng thái CV (${dataDetailCandidate.code_cv})`}
      open={isModalChangeStatus}
      onCancel={() => {
        setIsModalChangeStatus(false);
        form.resetFields();
      }}
      width={500}
      footer={false}
      className="resize-form"
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          onFinishChangeStatus(values);
        }}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
        validateMessages={validateMessages}
      >
        <Row>
          <Col lg={{ span: 15, offset: 1 }}>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Mã CV"
                  name="code_cv"
                  rules={[{ required: true }]}
                  hidden={true}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Trạng thái"
                  name="cv_status"
                  rules={[{ required: true }]}
                  initialValue={[]}
                >
                  <Select placeholder="Chọn trạng thái">
                    {listStatusCV
                      .filter(
                        (item) => item.id !== dataDetailCandidate.cv_status_id
                      )
                      .map((v) => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item name="why_change" label="Lý do chuyển trạng thái">
                  <Input.TextArea
                    autoSize={{
                      minRows: 3,
                    }}
                    placeholder="Nhập lý do chuyển trạng thái"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={{ span: 3, offset: 1 }} className="styleBtnExcel">
            <div className="brace-left">
              <div className="brace-top"></div>
              <div className="brace-bottom"></div>
            </div>
          </Col>
          <Col lg={{ span: 1 }} className="styleBtnExcel">
            {/* <Row > */}
            <Form.Item>
              <Button
                type={"primary"}
                className={"btnGreen"}
                htmlType={"submit"}
                title="Cập nhật"
              >
                <FileSyncOutlined className="styleIcon" />
              </Button>
            </Form.Item>
            {/* </Row> */}
          </Col>
        </Row>
        {/* <Row >
                <Col  lg={{ span: 23, offset: 1 }} style={{color:"gray"}}>
                    Lưu ý: <br></br>
                    - Kiểm tra kỹ thông tin trước khi chuyển trạng thái. <br></br>
                    - Sau khi chuyển trạng thái, kiểm tra lại trạng thái và lịch sử CV
                </Col>
            </Row> */}
      </Form>
    </Modal>
  );
};

const EMPTY_LIST = [];
const asList = (value) => (Array.isArray(value) ? value : EMPTY_LIST);

const index = () => {
  const [pager, setPager] = useState({ pageSize: 10, count: 0, current: 1 });
  const [form] = Form.useForm();
  const [currentBP, setCurrentBP] = useState([]);
  const [treeDataBP, setTreeDataBP] = useState([]);
  const [isModalOpenEditCandidate, setIsModalOpenEditCandidate] =
    useState(false);
  // const [isModalOpenViewMeeting, setIsModalOpenViewMeeting] = useState(false);
  // const [listStatusCV, setListStatusCV] = useState([]);
  // const [listFilterStatusCV, setListFilterStatusCV] = useState([]);
  const [dataCaditateManagement, setDataCaditateManagement] = useState([]);
  const [dataDetailCandidate, setDataDetailCandidate] = useState([]);
  // const [dataViewMeeting, setDataViewMeeting] = useState({});
  const [dataCheckCV, setDataCheckCV] = useState({});
  const [isModalOpenCheckCV, setIsModalOpenCheckCV] = useState(false);

  const [dateSearch, setDateSearch] = useState([
    moment(new Date()).subtract(6, "months"),
    moment(new Date()),
  ]);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [listEducationLevel, setListEducationLevel] = useState([]);
  const [listCandidateSource, setListCandidateSource] = useState([]);
  // const [listLanguageSkill, setListListLanguageSkill] = useState([]);

  const [uploadFileCV, setUploadFileCV] = useState(null);
  const [isModalChangeStatus, setIsModalChangeStatus] = useState(false);
  // const [startTime, setStartTime] = useState(false);
  // const [endTime, setEndTime] = useState(false);
  const [uploadFileNote, setUploadFileNote] = useState(null);

  const ls_city = useSelector((state) => asList(state.user.ls_city));
  const ls_department = useSelector((state) => asList(state.user.ls_department));
  const ls_cv_status = useSelector((state) => asList(state.user.ls_cv_status));
  // const [listMeetingRoom, setListMeetingRoom] = useState([]);
  const [typeEditForm, setTypeEditForm] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalAddCVInterview, setIsModalAddCVInterview] = useState(false);
  const [dataInterview, setDataInterview] = useState([]);
  const [listUserHR, setListUserHR] = useState([]);
  const screenWidth = useScreenSize();

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      className: "vertical-middle",
      fixed: "left",
      width: 80,
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
    },
    // {
    //   title: "Tiêu Đề YCTD",
    //   dataIndex: "title_recruitment",
    //   key: "title_recruitment",
    //   filterKey: "title_recruitment",
    //   className: "highlight vertical-middle",
    //   type: "text",
    //   canSearch: true,
    //   align: "center",
    //   width: 150,
    // },
    {
      title: "Vị trí TD",
      dataIndex: "cv_rec_position",
      key: "cv_rec_position",
      filterKey: "cv_rec_position",
      className: "highlight vertical-middle",
      type: "text",
      canSearch: true,
      align: "center",
      width: 170,
      fixed: "left",
      render: (text) => (
        <div
          style={{
            maxHeight: "70px",
            overflowY: "auto",
            whiteSpace: "normal",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Mã Yêu Cầu",
      dataIndex: "ticket_code",
      key: "ticket_code",
      filterKey: "ticket_code",
      className: "highlight vertical-middle",
      type: "text",
      canSearch: true,
      align: "center",
      width: 130,
    },
    {
      title: "Họ Và Tên",
      dataIndex: "name",
      key: "name",
      className: "vertical-middle",
      align: "center",
      ellipsis: true,
      canSearch: true,
      width: 250,
      render: (_, record) => (
        <div
          style={{
            maxHeight: "70px",
            overflowY: "auto",
            whiteSpace: "normal",
          }}
        >
          {record.last_name != null
            ? record.last_name + " " + record.first_name
            : record.first_name}
        </div>
      ),
    },
    {
      title: "Ngày Sinh",
      dataIndex: "birthday",
      key: "birthday",
      className: "vertical-middle",
      align: "center",
      render: (value, item, index) =>
        value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : null,
      width: 120,
    },
    {
      title: "Số Điện Thoại",
      dataIndex: "numberphone",
      key: "numberphone",
      className: "vertical-middle",
      align: "center",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "vertical-middle",
      align: "center",
      width: 250,
    },
    {
      title: "Trạng Thái CV",
      dataIndex: "cv_status_name",
      key: "cv_status_name",
      className: "vertical-middle",
      align: "center",
      width: 150,
      render: (value, item) => (
        <span
          className="btnStatus"
          style={{
            backgroundColor: item.color,
          }}
          onClick={() => handleClickChangeStatus(item)}
        >
          {value}
        </span>
      ),
    },
    // {
    //   title: "Người duyệt",
    //   dataIndex: "user_approve_name",
    //   key: "user_approve_name",
    //   className: "vertical-middle",
    //   align: "center",
    // },
    // {
    //   title: "Người tạo",
    //   dataIndex: "user_create_name",
    //   key: "user_create_name",
    //   className: "vertical-middle",
    //   align: "center",
    // },
    {
      title: "Phụ Trách Tuyển",
      dataIndex: "detail_user_received",
      key: "detail_user_received",
      filterKey: "detail_user_received",
      className: "vertical-middle",
      type: "text",
      canSearch: true,
      width: 150,
      // render: (text) => <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{ text.map((item) => item.username).join(", ")}</div>,
      render: (value, item, index) =>
        asList(value).map((item) => item.username).join(", "),
    },
    {
      title: "Ngày Tạo",
      dataIndex: "created",
      key: "created",
      className: "vertical-middle",
      align: "center",
      width: 150,
      render: (value, item, index) =>
        moment(value).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: "Thao Tác",
      key: "action",
      className: "vertical-middle",
      align: "center",
      width: 150,
      fixed: "right",
      render: (_, record) => (
        <Space size="small">
          <EditOutlined
            onClick={() => handleClickOpenEdit(record.id)}
            className="styleIcon"
            title="Chỉnh sửa"
          />
          {/* <ScheduleOutlined
            onClick={() => handleOpenViewMeeting(record)}
            className="styleIcon"
            title="Phòng họp"
          /> */}
          {/* <FileAddOutlined
            onClick={() => handleOpenAddInterview(record)}
            className="styleIcon"
            title="Phỏng vấn"
          /> */}
          <FileSearchOutlined
            onClick={() => handleOpenViewFindCV(record)}
            className="styleIcon"
            title="Tra soát hồ sơ"
          />
          <Popconfirm
            title="Xác nhận xóa?"
            okText="Xóa"
            onConfirm={() => handleDeleteCV(record)}
          >
            <DeleteOutlined
              style={{ color: "red" }}
              // onClick={}
              className="styleIcon"
              title="Xóa CV"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // const fetchListStatusCV = () => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_list_status_cv)
  //     .then((res) => {
  //       setListStatusCV(res.data);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       console.log(err);
  //       // openNotificationWithIcon('success','Thành công','');
  //     });
  // };

  const appliedFilters = useRef({});
  const listRequestId = useRef(0);

  const fetchListCV = (params = {}) => {
    appliedFilters.current = params;
    const requestId = ++listRequestId.current;
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(url_get_list_cv, { params: params })
      .then((res) => {
        if (requestId !== listRequestId.current) return;
        setDataCaditateManagement(asList(res.data.results));
        setListEducationLevel(asList(res.data.list_education_level));
        setListCandidateSource(asList(res.data.list_candidate_source));
        // setListListLanguageSkill(res.data.ls_language_skill);
        setListUserHR(asList(res.data.list_user_hr));
        setPager({
          current: params.page,
          pageSize: params.page_size,
          count: res.data.count,
        });
        setLoading(false);
      })
      .catch((err) => {
        if (requestId !== listRequestId.current) return;
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const fetchDetailCV = (params, setIsModalOpen) => {
    authAxios(cookies.get("token"))
      .get(url_get_detail_cv(params))
      .then((res) => {
        setDataDetailCandidate(res.data.results);
        setIsModalOpen(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
      });
  };

  // const fetchRegisMeeting = (params) => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_regis_meeting(params.id))
  //     .then((res) => {
  //       var dataMeeting = {};

  //       // 281124 Commnet code, vì mỗi lần DK xong thì để trống, ko view lại
  //       // if (res.data.length != 0) {
  //       //   dataMeeting = res.data[0];
  //       // }

  //       dataMeeting["id_cv"] = params.id;
  //       dataMeeting["code_cv"] = params.code_cv;
  //       setDataViewMeeting(dataMeeting);
  //       setIsModalOpenViewMeeting(true);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       console.log(err);
  //       // openNotificationWithIcon('success','Thành công','');
  //     });
  // };

  // const fetchMeetingRoom = (params) => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_meeting_room, { params })
  //     .then((res) => {
  //       setListMeetingRoom(res.data);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       console.log(err);
  //     });
  // };

  useEffect(() => {
    form.setFieldsValue({
      datepicker: dateSearch,
    });
    fetchListCV({
      page: pager.current,
      page_size: pager.pageSize,
      from_date: dateSearch[0].format("YYYY-MM-DD"),
      to_date: dateSearch[1].format("YYYY-MM-DD"),
    });
    // fetchListStatusCV();
    // fetchMeetingRoom();
  }, []);

  const onChangeBP = (value) => {
    if (value.length > 0) {
      setCurrentBP(value);
      form.setFieldsValue({
        department_recruited: value,
      });
    } else {
      setCurrentBP([]);
      form.setFieldsValue({
        department_recruited: undefined,
      });
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBP.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBP([]);
                }
              }}
              className="btn-tree-select"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBP(ls_department.map((item) => item.id));
                }
              }}
              className="btn-tree-select"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: false,
        className: "btn-tree-select",
      },
      ...treeDataBP,
    ],
    value: treeDataBP.length > 0 ? currentBP : undefined,
    onChange: onChangeBP,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 3,
    placeholder: "Chọn bộ phận",
    disabled: loading,
    allowClear: true,
    showSearch: false,
  };

  useEffect(() => {
    const return_bp = ls_department.map((item) => {
      return {
        title: item.name,
        value: item.id,
        key: item.id,
      };
    });
    setTreeDataBP(return_bp);
  }, [ls_department]);

  const handleClickOpenEdit = (id) => {
    // setIdEdit(id);
    fetchDetailCV(id, setIsModalOpenEditCandidate);
    setTypeEditForm(true);
  };

  // const handleOpenViewMeeting = (data) => {
  //   fetchRegisMeeting(data);
  // };

  const handleOpenViewFindCV = (data) => {
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(url_get_check_cv(data.id))
      .then((res) => {
        if (res.data.results.length == 0) {
          openNotificationWithIcon(
            "warn",
            "Không tìm thấy hồ sơ trùng lặp.",
            ""
          );
        } else {
          var dataCheckCV = {};
          dataCheckCV["code_cv"] = data.code_cv;
          dataCheckCV["data_duplicate"] = res.data;
          setDataCheckCV(dataCheckCV);
          setIsModalOpenCheckCV(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
        setLoading(false);
      });
  };

  const handleDeleteCV = (data) => {
    setLoading(true);
    let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_delete_data_cv, { id_cv: data.id })
      .then((res) => {
        fetchListCV({
          page: pager.current,
          page_size: pager.pageSize,
          from_date: dateSearch[0].format("YYYY-MM-DD"),
          to_date: dateSearch[1].format("YYYY-MM-DD"),
          department_recruited:
            get_form["department_recruited"] === undefined
              ? undefined
              : get_form["department_recruited"].join(", "),
          city_code: get_form["city_code"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
          ticket_code: get_form["ticket_code"],
          search: get_form["search"],
          user_received: get_form["user_received"],
        });
        openNotificationWithIcon("success", "xóa thông tin CV thành công", "");
        setLoading(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        // openNotificationWithIcon('success','Thành công','');
        setLoading(false);
      });
  };

  const handleClickChangeStatus = (item) => {
    setDataDetailCandidate(item);
    setIsModalChangeStatus(true);
  };

  const fetchListInterview = (params = {}) => {
    setLoadingModal(true);
    authAxios(cookies.get("token"))
      .get(url_get_list_interview, { params: params })
      .then((res) => {
        const events = res.data.results.map((item) => {
          // const startDateTime = `${item.start_date}T${item.time_start}`; // Kết hợp ngày và giờ
          // const endDateTime = `${item.start_date}T${item.time_end}`;
          return {
            ...item,
            title_interview: item.title, // Gộp name và content
            title: `${item.user_create_name} - ${item.title}`, // Gộp name và content
            // start: startDateTime,
            // end: endDateTime,
          };
        });
        setDataInterview(events);
        setLoadingModal(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
        setLoadingModal(false);
      });
  };

  const handleAddCVInterview = () => {
    setIsModalAddCVInterview(true);
  };

  const setRangeDate = (value) => {
    form.setFieldsValue({ datepicker: value });
  };

  const onFinish = (values) => {
    // Chức năng tìm kiếm
    setSelectedRowKeys([]);
    setDateSearch(values.datepicker);
    form.setFieldsValue({
      datepicker: values.datepicker,
    });

    fetchListCV({
      page: 1,
      page_size: pager.pageSize,
      from_date: values.datepicker[0].format("YYYY-MM-DD"),
      to_date: values.datepicker[1].format("YYYY-MM-DD"),
      department_recruited:
        values.department_recruited === undefined
          ? undefined
          : values.department_recruited.join(", "),
      // city_code: values.city_code,
      // district_code: values.district_code,
      // gender: values.gender,
      cv_status: values.cv_status,
      ticket_code: values.ticket_code,
      // first_name: values.first_name,
      search: values.search,
      user_received: values.user_received,
    });
  };

  const handleChangeUploadCV = (info) => {
    setUploadFileCV(info.fileList);
    if (info.fileList.length === 0) {
      setUploadFileCV(null);
    }
  };

  const handleChangeUploadNote = (info) => {
    if (info.fileList.length === 0) {
      setUploadFileNote(null);
    } else {
      setUploadFileNote(info.fileList);
    }
  };

  const onFinishAddCVInterview = (values, selectedRowKeys) => {
    // Thêm CV vào lịch PV
    var FormData = require("form-data");
    var data = new FormData();
    data.append("ls_id_cv", JSON.stringify(selectedRowKeys));
    data.append("id_interview", values.id_interview);

    // let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_add_cv_interview, data)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Thêm CV phỏng vấn thành công.",
          ""
        );
        setIsModalAddCVInterview(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const onDeleleFileCV = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("id_cv", values.id);
    data.append("name_file_cv", values.name_file_cv);
    authAxios(cookies.get("token"))
      .post(url_delete_file_cv, data)
      .then((res) => {
        openNotificationWithIcon("success", "Đã xóa file CV thành công", "");
        let data_cv = dataDetailCandidate;
        data_cv["name_file_cv"] = null;
        data_cv["path_file_cv"] = null;
        setDataDetailCandidate(undefined);
        setDataDetailCandidate(data_cv);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const onFinishEdit = (values) => {
    // Chức năng chỉnh sửa

    if (values.birthday !== undefined && values.birthday !== "") {
      values["birthday"] = values.birthday.format("YYYY-MM-DD");
    }
    if (
      values.application_date !== undefined &&
      values.application_date !== ""
    ) {
      values["application_date"] = values.application_date.format("YYYY-MM-DD");
    }

    var FormData = require("form-data");
    var data = new FormData();
    data.append("values", JSON.stringify(values));
    if (uploadFileCV != undefined) {
      data.append("file_upload", uploadFileCV[0].originFileObj);
    }
    if (uploadFileNote != undefined) {
      data.append("file_note", uploadFileNote[0].originFileObj);
    }

    let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .put(url_get_detail_cv(dataDetailCandidate.id), data)
      .then((res) => {
        fetchListCV({
          page: pager.current,
          page_size: pager.pageSize,
          from_date: dateSearch[0].format("YYYY-MM-DD"),
          to_date: dateSearch[1].format("YYYY-MM-DD"),
          department_recruited:
            get_form["department_recruited"] === undefined
              ? undefined
              : get_form["department_recruited"].join(", "),
          city_code: get_form["city_code"],
          // district_code: get_form["district_code"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
          ticket_code: get_form["ticket_code"],
          search: get_form["search"],
          user_received: get_form["user_received"],

          // first_name: get_form["first_name"],
        });
        setUploadFileCV(null);
        openNotificationWithIcon("success", "Lưu thông tin thành công", "");
        setIsModalOpenEditCandidate(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const onFinishChangeStatus = (values) => {
    // Chức năng Chuyển trạng thái CV
    var FormData = require("form-data");
    var data = new FormData();
    data.append("code_cv", values.code_cv);
    data.append("cv_status", values.cv_status);
    data.append("why_change", values.why_change);

    let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .put(url_change_status_cv(dataDetailCandidate.id), data)
      .then((res) => {
        fetchListCV({
          page: pager.current,
          page_size: pager.pageSize,
          from_date: dateSearch[0].format("YYYY-MM-DD"),
          to_date: dateSearch[1].format("YYYY-MM-DD"),
          department_recruited:
            get_form["department_recruited"] === undefined
              ? undefined
              : get_form["department_recruited"].join(", "),
          city_code: get_form["city_code"],
          // district_code: get_form["district_code"],
          gender: get_form["gender"],
          cv_status: get_form["cv_status"],
          ticket_code: get_form["ticket_code"],
          search: get_form["search"],
          user_received: get_form["user_received"],
        });
        openNotificationWithIcon("success", "Lưu thông tin thành công", "");
        setIsModalChangeStatus(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  // const onFinishRegisMeeting = (values) => {
  //   // Chức năng đăng ký phòng họp
  //   if (values.data.length == 0) {
  //     openNotificationWithIcon("error", "Vui lòng điền thông tin đang ký", "");
  //   }
  //   var FormData = require("form-data");
  //   var data = new FormData();
  //   data.append(
  //     "startDate",
  //     moment(values.data.startDate).format("YYYY-MM-DD")
  //   );
  //   data.append("startTime", moment(values.data.startTime).format("HH:mm"));
  //   data.append("endTime", moment(values.data.endTime).format("HH:mm"));
  //   data.append("title", values.data.title);
  //   data.append("phonghop_rel", values.data.phonghop_rel);
  //   data.append("id_cv", values.id_cv);

  //   authAxios(cookies.get("token"))
  //     .post(url_regis_meeting, data)
  //     .then((res) => {
  //       openNotificationWithIcon("success", "Đăng ký phòng họp thành công", "");
  //       setIsModalOpenViewMeeting(false);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       if (err.data.hasOwnProperty("message")) {
  //         openNotificationWithIcon("error", err.data.message, "");
  //       }
  //       console.log(err);
  //     });
  // };

  // const onFinishDeleteMeeting = (values) => {
  //   // Chức năng xóa đăng ký phòng họp
  //   if (values.data.length == 0) {
  //     openNotificationWithIcon("error", "Vui lòng điền thông tin đăng ký", "");
  //   }
  //   var FormData = require("form-data");
  //   var data = new FormData();
  //   data.append(
  //     "startDate",
  //     moment(values.data.startDate).format("YYYY-MM-DD")
  //   );
  //   data.append("id_schedule", values.id_schedule);
  //   data.append("id_cv", values.id_cv);
  //   data.append("type_api", "delete");

  //   authAxios(cookies.get("token"))
  //     .put(url_regis_meeting, data)
  //     .then((res) => {
  //       openNotificationWithIcon("success", "Xóa đăng ký thành công", "");
  //       setIsModalOpenViewMeeting(false);
  //       setDataViewMeeting([]);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       if (err.data.hasOwnProperty("message")) {
  //         openNotificationWithIcon("error", err.data.message, "");
  //       }
  //     });
  // };

  const handleChange = (pagination) => {
    setSelectedRowKeys([]);
    fetchListCV({
      ...appliedFilters.current,
      page_size: pagination.pageSize,
      page: pagination.current,
    });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const fileDownloadCV = (values) => {
    setLoading(true);

    let current_date = moment(new Date());
    const filename = "Report_CV__" + current_date.format("YYYYMMDD") + ".xlsx";
    let get_form = form.getFieldsValue();
    var FormData = require("form-data");
    var data = new FormData();
    // Lấy tương tự phần tìm kiếm
    data.append("from_date", get_form.datepicker[0].format("YYYY-MM-DD"));
    data.append("to_date", get_form.datepicker[1].format("YYYY-MM-DD"));
    data.append(
      "department_recruited",
      get_form["department_recruited"] === undefined
        ? undefined
        : get_form["department_recruited"].join(", ")
    );
    data.append("cv_status", get_form["cv_status"]);
    data.append("search", get_form["search"]);
    data.append("ticket_code", get_form["ticket_code"]);
    data.append("user_received", get_form["user_received"]);

    authAxios(cookies.get("token"))
      .post(url_export_cv, data, { responseType: "blob" })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fnFileDownload(blob, filename);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được danh sách. Bạn vui lòng thử lại."
        );
        setLoading(false);
      });
  };

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="cadidate-management-row">
          {/* <Col span={8}>
            <Form.Item
              label="Nhập từ khóa"
              className="cadidate-management-form-item"
            >
              <Input placeholder="Nhập từ khóa tìm kiếm"></Input>
            </Form.Item>
          </Col> */}
          <Col span={screenWidth <= 1348 ? 6 : 5}>
            <Form.Item
              label="Thời gian"
              name="datepicker"
              className="cadidate-management-form-item"
              {...rangeConfig}
            >
              <RangePicker
                ranges={{
                  "Hôm nay": [moment(), moment()],
                  "Tháng này": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Năm nay": [moment().startOf("year"), moment().endOf("year")],
                  "Năm ngoái": [
                    moment().add(-1, "year").startOf("year"),
                    moment().add(-1, "year").endOf("year"),
                  ],
                }}
                format="DD/MM/YYYY"
                // initialValues={[moment(new Date(), "DD/MM/YYYY"), moment(new Date(), "DD/MM/YYYY").add(7, 'days')]}
                onChange={(dates) => setRangeDate(dates)}
                allowClear={false}
              />
            </Form.Item>
          </Col>
          {/* <Col span={4}>
            <Form.Item
              label="Ngày ứng tuyển"
              name="application_date"
              className="cadidate-management-form-item"
            >
              <DatePicker disabledDate={disabledDate} style={{borderRadius:10}} className={'m-2'} format={'DD/MM/YYYY'} allowClear={true}/>

            </Form.Item>
          </Col> */}
          <Col span={screenWidth >= 1650 ? 3 : screenWidth >= 1348 ? 4 : 5}>
            <Form.Item
              label="Bộ phận tuyển dụng"
              name="department_recruited"
              className="cadidate-management-form-item"
            >
              {currentBP && <TreeSelect {...tPropsConfig_BoPhan} />}
            </Form.Item>
          </Col>
          {/* <Col span={3}>
            <Form.Item
              label="Tỉnh/Thành phố"
              name="city_code"
              className="cadidate-management-form-item"
            >
              <Select
                allowClear={true}
                placeholder="Chọn Tỉnh/Thành phố"
                // onChange={(e) => handleCityChange(e)}
                showSearch={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {ls_city != undefined &&
                  ls_city.map((item) => (
                    <Option key={item.code} value={item.code}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col> */}
          {/* <Col span={4}>
            <Form.Item
              label="Quận/Huyện"
              name="district_code"
              className="cadidate-management-form-item"
            >
              <Select allowClear={true} placeholder="Chọn Quận/Huyện">
                {lsDistrictCV.map((item) => (
                  <Option key={item.code} value={item.code}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}

          {/* <Col span={2}>
            <Form.Item
              label="Giới tính"
              name="gender"
              className="cadidate-management-form-item"
            >
              <Select allowClear={true} placeholder="Chọn giới tính">
                <Select.Option key={0} value={"Nam"}>
                  Nam
                </Select.Option>
                <Select.Option key={1} value={"Nữ"}>
                  Nữ
                </Select.Option>
              </Select>
            </Form.Item>
          </Col> */}

          <Col span={3}>
            <Form.Item
              label="Trạng thái CV"
              name="cv_status"
              className="cadidate-management-form-item"
            >
              <Select allowClear={true} placeholder="Trạng thái CV">
                {ls_cv_status.map((profile_status) => (
                  <Option key={profile_status.id} value={profile_status.id}>
                    {profile_status.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={screenWidth >= 1650 ? 4 : screenWidth >= 1348 ? 5 : 6}>
            <Form.Item
              label="Nhập từ khóa"
              name="search"
              className="cadidate-management-form-item"
            >
              <Input placeholder="Nhập Họ tên / SĐT"></Input>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              label="Mã yêu cầu"
              name="ticket_code"
              className="cadidate-management-form-item"
            >
              <Input placeholder="Nhập mã yêu cầu tuyển dụng"></Input>
            </Form.Item>
          </Col>
          <Col span={screenWidth >= 1348 ? 3 : 4}>
            <Form.Item
              label="Phụ trách tuyển"
              name="user_received"
              className="recruitment-requirements-form-item"
            >
              {/* <Input placeholder="Nhập username"></Input> */}
               <Input.Group compact>
                  <AutoComplete
                    style={{ width: "100%" }}
                    placeholder="Nhập username"
                    onChange={(value) => {
                      form.setFieldsValue({ user_received: value });
                    }}
                  >
                    {listUserHR.map((item) => (
                      <AutoComplete.Option key={item.id} value={item.username}>
                        {item.username}
                      </AutoComplete.Option>
                    ))}
                  </AutoComplete>
                </Input.Group>
            </Form.Item>
          </Col>
          <Col span={screenWidth >= 1650 ? 3 : 5}>
            <Form.Item label={" "} style={{ display: "inline-block" }}>
              <Button
                type="primary"
                className="cadidate-management-button big-icon"
                // size="large"
                htmlType={"submit"}
              >
                <SearchOutlined />
              </Button>
            </Form.Item>
            <Form.Item
              label={" "}
              style={{ marginLeft: "2%", display: "inline-block" }}
            >
              <Button
                type="primary"
                className="cadidate-management-button big-icon"
                onClick={handleAddCVInterview}
              >
                <ScheduleOutlined />
              </Button>
            </Form.Item>
            <Form.Item
              label={" "}
              style={{ marginLeft: "2%", display: "inline-block" }}
            >
              <Button
                type={"primary"}
                className={"cadidate-management-button btnGreen big-icon"}
                style={{ marginRight: 5, float: "right", marginLeft:0 }}
                onClick={fileDownloadCV}
                icon={<DownloadOutlined/>}
              ></Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row className="cadidate-management-row">
        <Table
          className="cadidate-management-table"
          columns={columns}
          dataSource={dataCaditateManagement}
          loading={loading}
          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: pager.count,
            showSizeChanger: true,
            showQuickJumper: false,
            pageSizeOptions: ["10", "50", "100", "150"],
          }}
          onChange={handleChange}
          scroll={{
            x: 768, // Kích thước ngang tự động điều chỉnh theo nội dung cột
            y: "62vh", // Chiều cao tối đa có thể lăn (thay số này để phù hợp với màn hình)
          }}
          rowKey="id" // Xác định khoá là `id`
          rowSelection={rowSelection}
          size="small"
        />
      </Row>
      {/* <ModalAddCandidate
        isModalOpenAddCandidate={isModalOpenAddCandidate}
        setIsModalOpenAddCandidate={setIsModalOpenAddCandidate}
      /> */}

      {isModalOpenEditCandidate && (
        <ModalEditCandidate
          typeEditForm={typeEditForm}
          isModalOpenEditCandidate={isModalOpenEditCandidate}
          setIsModalOpenEditCandidate={setIsModalOpenEditCandidate}
          dataDetailCandidate={dataDetailCandidate}
          // idEdit={idEdit}
          ls_city={ls_city}
          listEducationLevel={listEducationLevel}
          // listLanguageSkill={listLanguageSkill}
          listCandidateSource={listCandidateSource}
          handleChangeUploadCV={handleChangeUploadCV}
          uploadFileCV={uploadFileCV}
          setUploadFileCV={setUploadFileCV}
          onFinishEdit={onFinishEdit}
          listStatusCV={ls_cv_status}
          onDeleleFileCV={onDeleleFileCV}
          handleChangeUploadNote={handleChangeUploadNote}
          setUploadFileNote={setUploadFileNote}
        />
      )}
      {isModalChangeStatus && (
        <ModalChangeStatus
          isModalChangeStatus={isModalChangeStatus}
          setIsModalChangeStatus={setIsModalChangeStatus}
          dataDetailCandidate={dataDetailCandidate}
          listStatusCV={ls_cv_status}
          onFinishChangeStatus={onFinishChangeStatus}
        />
      )}

      {/* {isModalOpenViewMeeting && (
        <ModalViewMeeting
          isModalOpenViewMeeting={isModalOpenViewMeeting}
          setIsModalOpenViewMeeting={setIsModalOpenViewMeeting}
          dataViewMeeting={dataViewMeeting}
          onFinishRegisMeeting={onFinishRegisMeeting}
          onFinishDeleteMeeting={onFinishDeleteMeeting}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          startTime={startTime}
          endTime={endTime}
          listMeetingRoom={listMeetingRoom}
        />
      )} */}

      {isModalOpenCheckCV && (
        <ModalCheckCV
          isModalOpenCheckCV={isModalOpenCheckCV}
          setIsModalOpenCheckCV={setIsModalOpenCheckCV}
          dataCheckCV={dataCheckCV}
        />
      )}

      {isModalAddCVInterview && (
        <ModalAddCVInterview
          isModalAddCVInterview={isModalAddCVInterview}
          setIsModalAddCVInterview={setIsModalAddCVInterview}
          fetchListInterview={fetchListInterview}
          onFinishAddCVInterview={onFinishAddCVInterview}
          selectedRowKeys={selectedRowKeys}
          dataCaditateManagement={dataCaditateManagement}
          dataInterview={dataInterview}
        />
      )}
    </div>
  );
};

export default index;
